'use strict';

var CompetitorFaresChartLegendDirective = function CompetitorFaresChartLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/competitor-fares-chart-legend.html'),
    controller: 'CompetitorFaresChartLegendController',
    scope: {
      legendItems: '=',
      legendItemsCallback: '=',
      isCollapsible: '='
    },
    link: function link(scope, element) {
      element.on('mousedown, click', function (e) {
        e.stopImmediatePropagation();
      });
    }
  };
};
CompetitorFaresChartLegendDirective.$inject = [];
module.exports = CompetitorFaresChartLegendDirective;